import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RecaptchaModule } from 'ng-recaptcha';

import { UiKitDropdownComp } from './uikit.dropdown.comp';
import { UiKitModalDialogComp } from './uikit.modal.dialog';
import { UiKitDonationDriveModalComp } from './uikit.donationdrive.modal';
import { UiKitMultiSelectDropdownComp } from './uikit.multiselect.dropdown.comp';
import { UiKitConsentModalComp } from './uikit.consent.modal';
import { UiKitPromotionModalComp } from './student.promotion.popup';
import { UiKitAdditionalInfoModalComp } from './student.additionalinfo.popup';
import { TanzeelMessagingModule } from '../core/messaging/messaging.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TanzeelMessagingModule,
  ],
  declarations: [
    UiKitDropdownComp,
    UiKitModalDialogComp,
    UiKitDonationDriveModalComp,
    UiKitMultiSelectDropdownComp,
    UiKitConsentModalComp,
    UiKitPromotionModalComp,
    UiKitAdditionalInfoModalComp,
  ],
  exports: [
    UiKitDropdownComp,
    UiKitModalDialogComp,
    UiKitDonationDriveModalComp,
    UiKitMultiSelectDropdownComp,
    UiKitConsentModalComp,
    UiKitPromotionModalComp,
    UiKitAdditionalInfoModalComp,
    TanzeelMessagingModule,
  ],
})
export class UiKitModule {}
